import { NationalMenuTileData } from './types';

const sides: Array<NationalMenuTileData> = [
  {
    id: 'sides1',
    name: 'Breadsticks',
    mobileImageUrl: '/images/nationalMenu/sides/National_Sides_Breadsticks.jpg',
    desktopImageUrl: '/images/nationalMenu/sides/National_Sides_Breadsticks.jpg',
    productDescription: "Nobody does breadsticks like the Hut. Crispy-on-the-outside, soft-on-the-inside, and seasoned with garlic and parmesan, they're perfect with pizza or pasta. Comes with a cup of our delicious marinara!",
    priority: 0,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'sides2',
    name: 'Cheese Sticks',
    mobileImageUrl: '/images/nationalMenu/sides/National_Sides_Cheesesticks.png',
    desktopImageUrl: '/images/nationalMenu/sides/National_Sides_Cheesesticks.png',
    productDescription: 'A side everyone can agree on! Get these cheese sticks sprinkled with flavorful Italian seasoning and a cup of our delicious marinara.',
    priority: 0,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'sides3',
    name: 'Fries',
    mobileImageUrl: '/images/nationalMenu/sides/National_Sides_Fries.jpg',
    desktopImageUrl: '/images/nationalMenu/sides/National_Sides_Fries.jpg',
    productDescription: 'Add some crispy fries with or without our delicious seasoning. There’s no better wingman.',
    priority: 0,
    vegetarian: false,
    handleClick: () => {}
  }
];

export default sides;
